import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "./components/layout/DashboardLayout";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { UpgradePage } from "./pages/UpgradePage";
import { ActivatePage } from "./pages/ActivatePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PlanDetailPage } from "./pages/PlanDetailPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { PaymentPage } from "./pages/PaymentPage";
import { PaymentSuccessPage } from "./pages/PaymentSuccessPage";
import { AnalyticsPage } from "./pages/dashboard/AnalyticsPage";
import { BuilderPage } from "./pages/dashboard/BuilderPage";
import { DashboardHomePage } from "./pages/dashboard/DashboardHomePage";
import { ExportPage } from "./pages/dashboard/ExportPage";
import { OrdersPage } from "./pages/dashboard/OrdersPage";
import { ProductsPage } from "./pages/dashboard/ProductsPage";
import { SettingsPage } from "./pages/dashboard/SettingsPage";
import { WebsitePage } from "./pages/dashboard/WebsitePage";


const DevPlaygroundPage = import.meta.env.DEV
  ? lazy(() => import("./pages/dev/DevPlaygroundPage").then((module) => ({ default: module.DevPlaygroundPage })))
  : null;

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/siap-digital" element={<PlanDetailPage slug="siap-digital" />} />
      <Route path="/siap-profesional" element={<PlanDetailPage slug="siap-profesional" />} />
      <Route path="/siap-export" element={<PlanDetailPage slug="siap-export" />} />
      <Route path="/checkout/:slug" element={<CheckoutPage />} />
      <Route path="/payment/:token" element={<PaymentPage />} />
      <Route path="/payment/success/:token" element={<PaymentSuccessPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/upgrade/:token" element={<UpgradePage />} />
      <Route path="/activate/:token" element={<ActivatePage />} />

      {DevPlaygroundPage && (
        <Route
          path="/dev/playground"
          element={
            <Suspense fallback={<div className="grid min-h-screen place-items-center bg-[#f3f7f3] text-sm font-bold text-slate-500">Memuat development playground...</div>}>
              <DevPlaygroundPage />
            </Suspense>
          }
        />
      )}

      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<DashboardHomePage />} />
        <Route path="website" element={<WebsitePage />} />
        <Route path="builder" element={<BuilderPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="export" element={<ExportPage />} />
        <Route path="export/catalog" element={<ExportPage />} />
        <Route path="export/buyers" element={<ExportPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
